<!-- =========================================================================================
  File Name: AttendeeList.vue
  Description: Attendee List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>

  <div id="page-user-list">    
    <div class="vx-card p-6">
      <vs-input
      class="
        sm:mr-4
        mr-0
        sm:w-auto
        w-full
        sm:order-normal
        order-3
        sm:mt-0
        mt-4
      "
      v-model="attendeeId"
      placeholder="AttendeeId"
    />
    <vs-button type="gradient mr-4" v-on:click="fetchMeetingsbyAttendeeId()">Search</vs-button>
    <br><br>

    <table border="1" class="w-full">
      <thead>
        <th>SL</th>
        <th>MeetingId</th>
        <th>Meeting Slots</th>
        <th>M-Slots Count</th>
        <th>A-Slots Count</th>
        <th>Attendee Slots</th>
      </thead>
      <tbody>
        <tr v-for="(tr, indextr) in meetings">
          <td class="text-center">{{indextr+1}}</td>
          <td>{{tr.MeetingId}}</td>
          <td><pre>{{tr.Slots}}</pre></td>
          <td class="text-center">{{tr.Slots.length}}</td>
          <td class="text-center">{{tr.AttendeeSlots.length}}</td>
          <td><pre>{{tr.AttendeeSlots}}</pre></td>
        </tr>
      </tbody>
    </table>

    <!--
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <div class="flex flex-wrap items-center">         
            <vs-button type="gradient mr-4" disabled v-on:click="allPasswordReset ()">Generate Password for all Users</vs-button>
            {{ userspasswordchanged }}
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <div class="flex flex-wrap items-center">         
            <vs-button  type="gradient mr-4" v-on:click="allAttendeeEventMap ()">Mapp all Attendees</vs-button>
            {{ attendeeEventMap }}
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <div class="flex flex-wrap items-center">         
            <vs-button  type="gradient mr-4" v-on:click="businessCardExchangeDownload ()">Download Business Card Exchange</vs-button>
          </div>
        </div>
      </div>  
    -->
    </div>  
    <div class="vx-card p-6 d-none">
    <!-- <vs-button type="gradient mr-4" v-on:click="getAllBlankPasswordUsers()">Get All Blank Password Users</vs-button> -->
      <div class="flex flex-wrap items-center">
    
        <div class="flex-grow">
        <div v-if="users" >
        <!-- <vs-table :data="users">
          <template slot="thead">
            <vs-th>Email</vs-th>
            <vs-th>Name</vs-th>
            <vs-th>Action</vs-th>
          </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                <vs-td :data="data[indextr].email">
                  {{data[indextr].Email}}
                </vs-td>

                <vs-td :data="data[indextr].username">
                  {{data[indextr].Name}}
                </vs-td>

                <vs-td :data="data[indextr].AttendeeId">
                  <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].AttendeeId)" />
                </vs-td>
                
              </vs-tr>
            </template>
            </vs-table> -->
          </div>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import moment from "moment-timezone";
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleAttendeeManagement from '@/store/attendee-management/moduleAttendeeManagement.js'
import moduleMeetingManagement from "@/store/meeting-management/moduleMeetingManagement.js";
import ls from "@/common/localStorage"


var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
export default {
  components: {
    AgGridVue,
    vSelect,

    
  },
  data () {
    return {
      userspasswordchanged: null,
      attendeeEventMap: null,
      users:[],
      meetings: [],
      attendeeId: null
    }
  },
  watch: {
    
  },
  computed: {
    
  },
  filters: {
    pretty: function(value) {
      return JSON.stringify(JSON.parse(value), null, 2);
    }
  },
  methods: {
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    editRecord (id) {
      this.$router.push({ 
        name: 'attendee-edit', 
        params: {
                  AttendeeId: id
                } 
      }).catch(() => {})     
    },
    allPasswordReset()
    {
      if(ls.getSessionEventCollectionName())
      {
        if(confirm("Are you sure want to generate all USERS PASSWORD"))
        {
          this.userspasswordchanged = "Process started, have patience..."
          //this.$store.dispatch('attendeeManagement/allUserPasswordReset')
          this.$store.dispatch('attendeeManagement/allUserInstitutionCompanyCopy')
          .then(res => { 
            this.userspasswordchanged = res.message;       
           }) 
          .catch(err => {          
            //console.error(err) 
          })
        }
      }
      else
      {
        alert("Please select event!");
      }
      
    },
    getAllBlankPasswordUsers(){
      this.$store.dispatch('attendeeManagement/getAllBlankPasswordUsers')
        .then(res => { 
          this.users = res;       
         }) 
        .catch(err => {          
          //console.error(err) 
        })
    },
    businessCardExchangeDownload(){
      if(ls.getSessionEventCollectionName())
      {
          this.$store.dispatch('attendeeManagement/getAllbusinessCardExchange')
          .then(selectedRows => { 
            if(selectedRows.length){
              var datarow = [];

              datarow.push("Email");
              datarow.push("Name");
              datarow.push("Page");
              datarow.push("Event");
              datarow.push("Action");
              datarow.push("Date");
              var AttendeeData = [];
              AttendeeData.push(datarow);

              selectedRows.map((row) => {
                //---------------------------------------------------------
                datarow = [];

                var UserEmail = row.UserEmail == undefined ? "" : row.UserEmail;
                datarow.push(UserEmail);
                var Uname = row.Uname == undefined ? "" : row.Uname;
                datarow.push(Uname);          
                datarow.push(row.page ? row.page : null);
                datarow.push(row.event ? row.event : null);
                datarow.push(row.action ? row.action : null);
                var date = row.timestamp ? this.SetTimeByZone(new Date(row.timestamp.seconds * 1000).toUTCString(), Session_Event_TZ) : null;
                //var date = row.timestamp ? moment.tz(row.timestamp, Session_Event_TZ).format("DD MMM YYYY hh:mm:ss a") : null;
                datarow.push(date);

                AttendeeData.push(datarow);
                //---------------------------------------------------------
              });
              debugger;
              let csvContent = "data:text/csv;charset=utf-8,";
              var dt = new Date().toISOString().slice(0, 10);
              AttendeeData.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              var filename = "ExportUserLogin_" + "_" + dt + ".csv";
              var encodedUri = encodeURI(csvContent);
              var link = document.createElement("a");
              link.setAttribute("href", encodedUri);
              //link.setAttribute("id", "Participance_RT_" + row.TableId);
              link.setAttribute("download", filename);
              document.body.appendChild(link); // Required for FF

              link.click();
            }
            else
            {
              console.log("export completed")
            }

          })           
      }
      else
      {
        alert("Please select event!");
      }
    },
    allAttendeeEventMap(){
      if(ls.getSessionEventCollectionName())
      {
        if(confirm("Are you sure want to map all attendee to this event"))
        {
          this.attendeeEventMap = "Process started, have patience..."
          this.$store.dispatch('attendeeManagement/allAttendeeEventMap')
          //this.$store.dispatch('attendeeManagement/allUserEventMap')
          .then(res => { 
            console.log(res)
            this.attendeeEventMap = res.message;       
           }) 
          .catch(err => {          
            console.error(err) 
          })
        }
      }
      else
      {
        alert("Please select event!");
      }
    },
    fetchMeetingsbyAttendeeId(){
      if(this.attendeeId){
        this.$vs.loading();
        this.$store.dispatch("meetingManagement/fetchMeetingsbyAttendeeId", this.attendeeId).then((res) => {
          this.meetings = res;
          this.$vs.loading.close();
        }).catch(err=>{
          this.$vs.loading.close();
        })
      }
    }

  },
  mounted () {


  },
  created () {
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule('attendeeManagement', moduleAttendeeManagement)
      moduleAttendeeManagement.isRegistered = true
    } 
    if (!moduleMeetingManagement.isRegistered) {
      this.$store.registerModule("meetingManagement", moduleMeetingManagement);
      moduleMeetingManagement.isRegistered = true;
    }
    

  }
}
 
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>